import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "springWaterDetail debug"
};
const _hoisted_2 = {
  class: "desTitle",
  id: "desTitle"
};
const _hoisted_3 = {
  key: 1,
  class: "containRelicsImg"
};
const _hoisted_4 = {
  class: "imagslist"
};
const _hoisted_5 = {
  class: "swiper-container swiperImg",
  ref: "swiperImg"
};
const _hoisted_6 = {
  class: "swiper-wrapper"
};
const _hoisted_7 = {
  class: "swiper-slide"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "imgbox",
  id: "imgbox"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "nav_bottom"
};
const _hoisted_12 = {
  class: "swiper-container",
  ref: "swipercontainer"
};
const _hoisted_13 = {
  class: "swiper-wrapper"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["src"];
const _hoisted_16 = ["id"];
const _hoisted_17 = ["id"];
const _hoisted_18 = {
  key: 2,
  class: "debug debugLight"
};
const _hoisted_19 = {
  class: "columnWarp"
};
const _hoisted_20 = {
  class: "column columnSlider"
};
const _hoisted_21 = {
  class: "column columnSlider"
};
const _hoisted_22 = {
  class: "column columnSlider"
};
const _hoisted_23 = {
  class: "column columnSlider"
};
const _hoisted_24 = {
  key: 3,
  class: "debug debugRight"
};
const _hoisted_25 = {
  class: "columnWarp"
};
const _hoisted_26 = {
  class: "modelWarp"
};
const _hoisted_27 = {
  key: 0,
  class: "column"
};
const _hoisted_28 = {
  class: "column"
};
const _hoisted_29 = {
  class: "column columnSlider"
};
const _hoisted_30 = {
  class: "column"
};
const _hoisted_31 = {
  key: 0,
  class: "column"
};
const _hoisted_32 = {
  key: 1,
  class: "column columnSlider"
};
const _hoisted_33 = {
  key: 4,
  class: "btns"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_slider = _resolveComponent("el-slider");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_radio = _resolveComponent("el-radio");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($data.detail.name), 1), $data.detail.type == '3D' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    id: "containRelics",
    style: _normalizeStyle(`${$data.showModels[1] || $data.showModels[0] ? `${$options.isMobile ? 'right: 100vw' : 'right: -22vw'}` : ''}`)
  }, null, 4)) : _createCommentVNode("", true), $data.detail.type == '图片' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.detail.images, item => {
    return _openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("img", {
      src: item
    }, null, 8, _hoisted_8)]);
  }), 256))])], 512)]), _cache[22] || (_cache[22] = _createElementVNode("div", {
    class: "prev btn fc_l"
  }, null, -1)), _cache[23] || (_cache[23] = _createElementVNode("div", {
    class: "next btn fc_r"
  }, null, -1))])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", {
    class: "containRelics360",
    style: _normalizeStyle(`${$data.showModels[1] || $data.showModels[0] ? `${$options.isMobile ? 'right: 100vw' : 'right: -22vw'}` : ''}`)
  }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.detail.images360, item => {
    return _openBlock(), _createElementBlock("li", null, [_createElementVNode("img", {
      src: item
    }, null, 8, _hoisted_10)]);
  }), 256))])]), _cache[24] || (_cache[24] = _createElementVNode("div", {
    id: "threesixty"
  }, [_createElementVNode("div", {
    id: "spinner"
  }, [_createElementVNode("span", null, "0%")]), _createElementVNode("ol", {
    id: "threesixty_images"
  })], -1))], 4), [[_vShow, $data.detail.type == '360']]), _createElementVNode("div", _hoisted_11, [_cache[25] || (_cache[25] = _createElementVNode("div", {
    class: "btnTurnLeft"
  }, null, -1)), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(`swiper-slide ${item.code == this.detailCode ? 'activeDetail' : ''}`),
      onClick: $event => $options.clickDetail(item.code)
    }, [_createElementVNode("img", {
      src: item.img
    }, null, 8, _hoisted_15)], 10, _hoisted_14);
  }), 256))])], 512), _cache[26] || (_cache[26] = _createElementVNode("div", {
    class: "btnTurnRight"
  }, null, -1))]), _createElementVNode("div", {
    id: `loadbar_${$data.detail.code}`,
    class: "loadbar"
  }, [_createElementVNode("span", {
    id: `bar_${$data.detail.code}`,
    style: {
      "width": "0%"
    },
    class: "bar"
  }, null, 8, _hoisted_17)], 8, _hoisted_16), $data.showDebug ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_cache[31] || (_cache[31] = _createElementVNode("div", {
    class: "debugTitle"
  }, "光线信息", -1)), _createElementVNode("div", _hoisted_20, [_cache[27] || (_cache[27] = _createElementVNode("span", {
    style: {
      "letter-spacing": "7px"
    }
  }, "高光", -1)), _createVNode(_component_el_slider, {
    modelValue: $data.light.highlight,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.light.highlight = $event),
    step: 0.01,
    max: 5,
    min: 0,
    "show-input": true,
    onChange: _cache[1] || (_cache[1] = $event => $options.changeLight('highlight'))
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_21, [_cache[28] || (_cache[28] = _createElementVNode("span", null, "平行光", -1)), _createVNode(_component_el_slider, {
    modelValue: $data.light.parallelLight,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.light.parallelLight = $event),
    step: 0.01,
    max: 5,
    min: 0,
    "show-input": true,
    onChange: _cache[3] || (_cache[3] = $event => $options.changeLight('parallelLight'))
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_22, [_cache[29] || (_cache[29] = _createElementVNode("span", null, "点光源", -1)), _createVNode(_component_el_slider, {
    modelValue: $data.light.pointLight,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.light.pointLight = $event),
    step: 0.01,
    max: 5,
    min: 0,
    "show-input": true,
    onChange: _cache[5] || (_cache[5] = $event => $options.changeLight('pointLight'))
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_23, [_cache[30] || (_cache[30] = _createElementVNode("span", null, "环境光", -1)), _createVNode(_component_el_slider, {
    modelValue: $data.light.envLight,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.light.envLight = $event),
    step: 0.1,
    max: 5,
    min: 0,
    "show-input": true,
    onChange: _cache[7] || (_cache[7] = $event => $options.changeLight('envLight'))
  }, null, 8, ["modelValue"])])])])) : _createCommentVNode("", true), $data.showDebug ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_cache[46] || (_cache[46] = _createElementVNode("div", {
    class: "debugTitle"
  }, "空间信息", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.space.attributeModels, (item, index) => {
    return _openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("div", null, "模型" + _toDisplayString(index + 1), 1), $data.space.attributeModels.length ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_cache[32] || (_cache[32] = _createElementVNode("span", null, "x轴距离", -1)), _createVNode(_component_el_input, {
      modelValue: item.axisX,
      "onUpdate:modelValue": $event => item.axisX = $event,
      onChange: $event => $options.changeSpaceAxis('axisX', index)
    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]), _cache[33] || (_cache[33] = _createElementVNode("span", null, "y轴距离", -1)), _createVNode(_component_el_input, {
      modelValue: item.axisY,
      "onUpdate:modelValue": $event => item.axisY = $event,
      onChange: $event => $options.changeSpaceAxis('axisY', index)
    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]), _cache[34] || (_cache[34] = _createElementVNode("span", null, "z轴距离", -1)), _createVNode(_component_el_input, {
      modelValue: item.axisZ,
      "onUpdate:modelValue": $event => item.axisZ = $event,
      onChange: $event => $options.changeSpaceAxis('axisZ', index)
    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_28, [_cache[35] || (_cache[35] = _createElementVNode("span", null, "x轴角度", -1)), _createVNode(_component_el_input, {
      modelValue: item.angleX,
      "onUpdate:modelValue": $event => item.angleX = $event,
      onChange: $event => $options.changeSpaceAngle('angleX', index)
    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]), _cache[36] || (_cache[36] = _createElementVNode("span", null, "y轴角度", -1)), _createVNode(_component_el_input, {
      modelValue: item.angleY,
      "onUpdate:modelValue": $event => item.angleY = $event,
      onChange: $event => $options.changeSpaceAngle('angleY', index)
    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]), _cache[37] || (_cache[37] = _createElementVNode("span", null, "z轴角度", -1)), _createVNode(_component_el_input, {
      modelValue: item.angleZ,
      "onUpdate:modelValue": $event => item.angleZ = $event,
      onChange: $event => $options.changeSpaceAngle('angleZ', index)
    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])])]);
  }), 256)), _createElementVNode("div", _hoisted_29, [_cache[38] || (_cache[38] = _createElementVNode("span", null, "缩放倍数", -1)), _createVNode(_component_el_slider, {
    modelValue: $data.space.scaleLimit,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.space.scaleLimit = $event),
    step: 0.01,
    max: 10,
    min: 0.01,
    onChange: _cache[9] || (_cache[9] = $event => $options.changeSpace('scaleLimit'))
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_30, [_cache[41] || (_cache[41] = _createElementVNode("span", null, "模型中心点    ", -1)), _createVNode(_component_el_radio, {
    modelValue: $data.space.modelCenter,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.space.modelCenter = $event),
    label: "开启",
    onChange: _cache[11] || (_cache[11] = $event => $options.changeModelCenter('open'))
  }, {
    default: _withCtx(() => [...(_cache[39] || (_cache[39] = [_createTextVNode("开启", -1)]))]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_radio, {
    modelValue: $data.space.modelCenter,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.space.modelCenter = $event),
    label: "关闭",
    onChange: _cache[13] || (_cache[13] = $event => $options.changeModelCenter('close'))
  }, {
    default: _withCtx(() => [...(_cache[40] || (_cache[40] = [_createTextVNode("关闭(关闭效果无法预览，会直接保存)", -1)]))]),
    _: 1
  }, 8, ["modelValue"])]), $data.detail.attribute3d.hasAutoTrans ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_cache[44] || (_cache[44] = _createElementVNode("span", null, "文物自动旋转    ", -1)), _createVNode(_component_el_radio, {
    modelValue: $data.space.autoTrans,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.space.autoTrans = $event),
    label: "开启",
    onChange: _cache[15] || (_cache[15] = $event => $options.changeTrans('open'))
  }, {
    default: _withCtx(() => [...(_cache[42] || (_cache[42] = [_createTextVNode("开启", -1)]))]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_radio, {
    modelValue: $data.space.autoTrans,
    "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $data.space.autoTrans = $event),
    label: "关闭",
    onChange: _cache[17] || (_cache[17] = $event => $options.changeTrans('close'))
  }, {
    default: _withCtx(() => [...(_cache[43] || (_cache[43] = [_createTextVNode("关闭", -1)]))]),
    _: 1
  }, 8, ["modelValue"])])) : _createCommentVNode("", true), $data.detail.attribute3d.transSpeed && $data.space.autoTrans == '开启' ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_cache[45] || (_cache[45] = _createElementVNode("span", null, "文物旋转速率    ", -1)), _createVNode(_component_el_slider, {
    modelValue: $data.space.transSpeed,
    "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.space.transSpeed = $event),
    step: 0.01,
    max: 5,
    min: 0,
    onChange: _cache[19] || (_cache[19] = $event => $options.changeTrans('speed'))
  }, null, 8, ["modelValue"])])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), $data.showDebug ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_cache[47] || (_cache[47] = _createElementVNode("div", {
    class: "debugButton"
  }, "预览", -1)), _createElementVNode("div", {
    class: "debugButton",
    onClick: _cache[20] || (_cache[20] = (...args) => $options.reset && $options.reset(...args))
  }, "重置"), _createElementVNode("div", {
    class: "debugButton",
    onClick: _cache[21] || (_cache[21] = $event => $options.saveParams())
  }, "保存")])) : _createCommentVNode("", true)]);
}